module.exports = __webpack_public_path__ + "img/T4-C-xh_15.ee48cd58.png";